var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { joiResolver } from '@hookform/resolvers/joi';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@interfaces/keychain.interface';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { fetchPhishingAccounts } from '@popup/steem/actions/phishing.actions';
import AccountUtils from '@popup/steem/utils/account.utils';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import { FavoriteUserUtils } from '@popup/steem/utils/favorite-user.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import SteemUtils from '@popup/steem/utils/steem.utils';
import TransferUtils from '@popup/steem/utils/transfer.utils';
import Joi from 'joi';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { BalanceSectionComponent } from 'src/common-ui/balance-section/balance-section.component';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { ComplexeCustomSelect, } from 'src/common-ui/custom-select/custom-select.component';
import { FormContainer } from 'src/common-ui/form-container/form-container.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { FormInputComponent } from 'src/common-ui/input/form-input.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import { Screen } from 'src/reference-data/screen.enum';
import { FormUtils } from 'src/utils/form.utils';
import FormatUtils from 'src/utils/format.utils';
import Logger from 'src/utils/logger.utils';
const transferFormRules = FormUtils.createRules({
    receiverUsername: Joi.string().required(),
});
const TransferFunds = ({ activeAccount, navParams, currencyLabels, phishing, formParams, localAccounts, setErrorMessage, setSuccessMessage, navigateToWithParams, navigateTo, fetchPhishingAccounts, addToLoadingList, removeFromLoadingList, setTitleContainerProperties, }) => {
    const { control, handleSubmit, setValue, watch } = useForm({
        defaultValues: {
            receiverUsername: formParams.receiverUsername
                ? formParams.receiverUsername
                : '',
            selectedCurrency: formParams.selectedCurrency
                ? formParams.selectedCurrency
                : navParams.selectedCurrency,
            amount: formParams.amount ? formParams.amount : '',
            memo: formParams.memo ? formParams.memo : '',
            encrypted: formParams.encrypted ? formParams.encrypted : false,
        },
        resolver: (values, context, options) => {
            const resolver = joiResolver(transferFormRules, { context: { balance: balance }, errors: { render: true } });
            return resolver(values, { balance: balance }, options);
        },
    });
    const [balance, setBalance] = useState('...');
    const [balances, setBalances] = useState({
        steem: 0,
        sbd: 0,
        sp: 0,
        hive: 0,
        hbd: 0,
        hp: 0,
        blurt: 0,
        bp: 0,
        time: 0,
    });
    const [loading, setLoading] = useState(true);
    const [autocompleteFavoriteUsers, setAutocompleteFavoriteUsers] = useState({
        categories: [],
    });
    useEffect(() => {
        const fetchBalances = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                setLoading(true);
                // Recupera il balance di TIME
                const timeBalance = yield AccountUtils.getTime(activeAccount.name);
                const hiveBalance = yield AccountUtils.getHive(activeAccount.name);
                const hbdBalance = yield AccountUtils.getHbd(activeAccount.name);
                const hpBalance = yield AccountUtils.getHp(activeAccount.name);
                const blurtBalance = yield AccountUtils.getBlurt(activeAccount.name);
                const bpBalance = yield AccountUtils.getBp(activeAccount.name);
                // Aggiorna lo stato balances
                setBalances({
                    steem: FormatUtils.toNumber(activeAccount.account.balance),
                    sbd: FormatUtils.toNumber(activeAccount.account.sbd_balance),
                    sp: 0,
                    hive: hiveBalance,
                    hbd: hbdBalance,
                    hp: hpBalance,
                    blurt: blurtBalance,
                    bp: bpBalance,
                    time: timeBalance,
                });
            }
            catch (err) {
                console.error('Error fetching balances:', err);
                setBalances({
                    steem: FormatUtils.toNumber(activeAccount.account.balance),
                    sbd: FormatUtils.toNumber(activeAccount.account.sbd_balance),
                    sp: 0,
                    hive: 0,
                    hbd: 0,
                    hp: 0,
                    blurt: 0,
                    bp: 0,
                    time: 0,
                });
            }
            finally {
                setLoading(false);
            }
        });
        if (activeAccount && activeAccount.name) {
            fetchBalances();
        }
        else {
            setBalances({
                steem: 0,
                sbd: 0,
                sp: 0,
                hive: 0,
                hbd: 0,
                hp: 0,
                blurt: 0,
                bp: 0,
                time: 0,
            });
            setLoading(false);
        }
    }, [activeAccount]);
    useEffect(() => {
        // Forza encrypted a false per i trasferimenti TIME
        if (watch('selectedCurrency') === 'time') {
            setValue('encrypted', false);
        }
    }, [watch('selectedCurrency'), setValue]);
    useEffect(() => {
        fetchPhishingAccounts();
        loadAutocompleteTransferUsernames();
        setTitleContainerProperties({
            title: 'popup_html_transfer_funds',
            isBackButtonEnabled: true,
        });
    }, []);
    useEffect(() => {
        setBalance(balances[watch('selectedCurrency')]);
    }, [watch('selectedCurrency'), balances]);
    const options = [
        { label: currencyLabels.steem, value: 'steem' },
        { label: currencyLabels.sbd, value: 'sbd' },
        { label: currencyLabels.hive, value: 'hive' },
        { label: currencyLabels.hbd, value: 'hbd' },
        { label: currencyLabels.blurt, value: 'blurt' },
        { label: currencyLabels.time, value: 'time' },
    ];
    const loadAutocompleteTransferUsernames = () => __awaiter(void 0, void 0, void 0, function* () {
        const autoCompleteListByCategories = yield FavoriteUserUtils.getAutocompleteListByCategories(activeAccount.name, localAccounts, { addExchanges: true, token: watch('selectedCurrency').toUpperCase() });
        setAutocompleteFavoriteUsers(autoCompleteListByCategories);
    });
    const setAmountToMaxValue = () => {
        setValue('amount', parseFloat(balance.toString()));
    };
    const getFormParams = () => {
        return watch();
    };
    const handleClickOnSend = (form) => __awaiter(void 0, void 0, void 0, function* () {
        if (form.amount <= 0) {
            setErrorMessage('popup_html_need_positive_amount');
            return;
        }
        if (parseFloat(form.amount.toString()) > parseFloat(balance.toString())) {
            setErrorMessage('popup_html_power_up_down_error');
            return;
        }
        const formattedAmount = `${parseFloat(form.amount.toString()).toFixed(3)} ${currencyLabels[form.selectedCurrency]}`;
        const stringifiedAmount = `${FormatUtils.formatCurrencyValue(parseFloat(form.amount.toString()))} ${currencyLabels[form.selectedCurrency]}`;
        let memoField = form.memo;
        if (form.memo.length) {
            if ((form.memo.startsWith('#') || form.encrypted) &&
                form.selectedCurrency !== 'time') {
                memoField = `${form.memo} (${getMessage('popup_encrypted')})`;
                if (!activeAccount.keys.memo) {
                    setErrorMessage('popup_html_memo_key_missing');
                    return;
                }
            }
        }
        else {
            memoField = getMessage('popup_empty');
        }
        let fields = [
            { label: 'popup_html_transfer_from', value: `@${activeAccount.name}` },
            { label: 'popup_html_transfer_to', value: `@${form.receiverUsername}` },
            { label: 'popup_html_transfer_amount', value: stringifiedAmount },
            { label: 'popup_html_transfer_memo', value: memoField },
        ];
        let warningMessage = yield TransferUtils.getTransferWarning(form.receiverUsername, currencyLabels[form.selectedCurrency], form.memo, phishing);
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_transfer_confirm_text'),
            fields: fields,
            warningMessage: warningMessage,
            skipWarningTranslation: true,
            title: 'popup_html_transfer_funds',
            formParams: getFormParams(),
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_transfer_fund_operation', KeysUtils.getKeyType(activeAccount.keys.active, activeAccount.keys.activePubkey));
                try {
                    let success;
                    let memoParam = form.memo;
                    if (form.memo.length) {
                        if ((form.memo.startsWith('#') || form.encrypted) &&
                            form.selectedCurrency !== 'time') {
                            if (!activeAccount.keys.memo) {
                                setErrorMessage('popup_html_memo_key_missing');
                                return;
                            }
                            else {
                                memoParam = SteemUtils.encodeMemo(`${!form.memo.startsWith('#') ? '#' : ''}${form.memo}`, activeAccount.keys.memo.toString(), yield AccountUtils.getPublicMemo(form.receiverUsername));
                            }
                        }
                    }
                    let key = activeAccount.keys.active;
                    // console.log('currency: ', formattedAmount.split(' ')[1]);
                    if (formattedAmount.split(' ')[1] === 'HIVE') {
                        key = activeAccount.keys.activehive;
                    }
                    if (formattedAmount.split(' ')[1] === 'HBD') {
                        key = activeAccount.keys.activehive;
                    }
                    if (formattedAmount.split(' ')[1] === 'BLURT') {
                        key = activeAccount.keys.activeblurt;
                    }
                    // console.log('key: ', key);
                    success = yield TransferUtils.sendTransfer(activeAccount.name, form.receiverUsername, formattedAmount, memoParam, 
                    //            activeAccount.keys.active!,
                    key, options);
                    removeFromLoadingList('html_popup_transfer_fund_operation');
                    if (success) {
                        navigateTo(Screen.HOME_PAGE, true);
                        yield FavoriteUserUtils.saveFavoriteUser(form.receiverUsername, activeAccount);
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else {
                            setSuccessMessage('popup_html_transfer_successful', [
                                `@${form.receiverUsername}`,
                                stringifiedAmount,
                            ]);
                        }
                    }
                    else {
                        setErrorMessage('popup_html_transfer_failed');
                    }
                }
                catch (err) {
                    Logger.error(err);
                    setErrorMessage(err.message, err.messageParams);
                }
                finally {
                    removeFromLoadingList('html_popup_transfer_fund_operation');
                }
            }),
        });
    });
    if (loading) {
        return React.createElement("div", null, "Loading balances...");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "transfer-funds-page", "data-testid": `${Screen.TRANSFER_FUND_PAGE}-page` },
            React.createElement(BalanceSectionComponent, { user: `${activeAccount.name}`, value: balance, unit: currencyLabels[watch('selectedCurrency')], label: "popup_html_balance" }),
            React.createElement(FormContainer, { onSubmit: handleSubmit(handleClickOnSend) },
                React.createElement("div", { className: "form-fields" },
                    React.createElement(FormInputComponent, { name: "receiverUsername", control: control, dataTestId: "input-username", type: InputType.TEXT, logo: SVGIcons.INPUT_AT, placeholder: "popup_html_username", label: "popup_html_username", autocompleteValues: autocompleteFavoriteUsers }),
                    React.createElement("div", { className: "value-panel" },
                        React.createElement(ComplexeCustomSelect, { label: "popup_html_currency", options: options, selectedItem: {
                                value: watch('selectedCurrency'),
                                label: currencyLabels[watch('selectedCurrency')],
                            }, setSelectedItem: (item) => setValue('selectedCurrency', item.value) }),
                        React.createElement("div", { className: "value-input-panel" },
                            React.createElement(FormInputComponent, { name: "amount", control: control, dataTestId: "amount-input", type: InputType.NUMBER, label: "popup_html_transfer_amount", placeholder: "0.000", skipPlaceholderTranslation: true, min: 0, rightActionClicked: setAmountToMaxValue, rightActionIcon: SVGIcons.INPUT_MAX }))),
                    React.createElement(FormInputComponent, { name: "memo", control: control, dataTestId: "input-memo-optional", type: InputType.TEXT, label: "popup_html_memo_optional", placeholder: "popup_html_memo_optional", rightActionClicked: watch('selectedCurrency') !== 'time'
                            ? () => setValue('encrypted', !watch('encrypted'))
                            : undefined, rightActionIcon: watch('selectedCurrency') !== 'time'
                            ? watch('encrypted')
                                ? SVGIcons.INPUT_ENCRYPT
                                : SVGIcons.INPUT_DECRYPT
                            : undefined }),
                    React.createElement("div", { className: "memo-status" }, watch('selectedCurrency') !== 'time' && watch('encrypted')
                        ? 'Note: Memo encryption enabled'
                        : '')),
                React.createElement(OperationButtonComponent, { dataTestId: "send-transfer", requiredKey: KeychainKeyTypesLC.active, onClick: handleSubmit(handleClickOnSend), label: 'popup_html_send_transfer' })))));
};
const mapStateToProps = (state) => {
    var _a, _b, _c;
    return {
        activeAccount: state.steem.activeAccount,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        navParams: state.navigation.stack[0].params,
        formParams: ((_b = state.navigation.stack[0].previousParams) === null || _b === void 0 ? void 0 : _b.formParams)
            ? (_c = state.navigation.stack[0].previousParams) === null || _c === void 0 ? void 0 : _c.formParams
            : {},
        phishing: state.steem.phishing,
        localAccounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    setErrorMessage,
    setSuccessMessage,
    navigateToWithParams,
    navigateTo,
    fetchPhishingAccounts,
    addToLoadingList,
    removeFromLoadingList,
    setTitleContainerProperties,
});
export const TransferFundsComponent = connector(TransferFunds);
